var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotfound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 504.6 331.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4,.cls-5,.cls-7{fill:none;}.cls-1,.cls-2,.cls-5,.cls-7{stroke:#f9b233;}.cls-1,.cls-11,.cls-2,.cls-4,.cls-5{stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:7.17px;}.cls-2{fill:#f9b233;stroke-width:4.83px;}.cls-12,.cls-3,.cls-8{opacity:0.36;}.cls-4,.cls-6{stroke:#fa691a;}.cls-4{stroke-width:4.78px;}.cls-5,.cls-7{stroke-width:5.12px;}.cls-6{fill:#fa691a;}.cls-10,.cls-6,.cls-7,.cls-9{stroke-miterlimit:10;}.cls-8{fill:#bcbec0;}.cls-9{fill:#f2eab9;stroke-width:1.71px;}.cls-10,.cls-11,.cls-9{stroke:#808285;}.cls-10{fill:#faf7e4;}.cls-10,.cls-11{stroke-width:1.71px;}.cls-11{fill:#fff;}.cls-12{fill:#b5b5b5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notfound") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.85,
    y1: 26.04,
    x2: 54.85,
    y2: 38.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.85,
    y1: 65.27,
    x2: 54.85,
    y2: 77.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.68,
    y1: 51.87,
    x2: 68.25,
    y2: 51.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.45,
    y1: 51.87,
    x2: 29.02,
    y2: 51.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 438.33,
    y1: 138.33,
    x2: 438.33,
    y2: 144.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 438.33,
    y1: 156.83,
    x2: 438.33,
    y2: 162.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 450.51,
    y1: 150.52,
    x2: 444.65,
    y2: 150.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 432.01,
    y1: 150.52,
    x2: 426.14,
    y2: 150.52
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 383.16,
    y1: 123.85,
    x2: 378.23,
    y2: 128.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 367.6,
    y1: 139.41,
    x2: 362.68,
    y2: 144.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 383.16,
    y1: 144.34,
    x2: 378.23,
    y2: 139.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 367.6,
    y1: 128.78,
    x2: 362.68,
    y2: 123.85
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 15.73,
    cy: 215.98,
    r: 13.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 74.21,
    cy: 114.44,
    r: 5.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 377.93,
    cy: 280.44,
    r: 6.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 380.16,
    cy: 14.92,
    r: 12.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M388.87,65.49a14.27,14.27,0,0,1-14.28,14.29h-83a12.07,12.07,0,0,1-5.05,23H271.4a13.61,13.61,0,0,1,3.73,21.9,13.73,13.73,0,0,1-4.26,2.89h34.39a12.09,12.09,0,1,1,0,24.17H174.67a12.1,12.1,0,0,1-8.55-20.64,11.7,11.7,0,0,1,3.52-2.42H138a13.63,13.63,0,0,1,0-27.25h12.36a12.09,12.09,0,0,1,.49-21.7H110.39a14.29,14.29,0,1,1,0-28.57h83.23a11.38,11.38,0,0,0,1.3-1.11A12.1,12.1,0,0,0,192,30.86H156.67a12.84,12.84,0,0,1,0-25.68H328.6a12.84,12.84,0,0,1,0,25.68H297.12a12.08,12.08,0,0,0-1.62,20.35h79.09A14.29,14.29,0,0,1,388.87,65.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M425.66,194.23v.94A11.68,11.68,0,0,1,414,206.86H377.64a11.39,11.39,0,0,0-2.54,1.92,12,12,0,0,0,2.1,18.75h24.22a13.21,13.21,0,0,1,0,26.41H273.09a13.2,13.2,0,0,1-6.79-24.53h-4.06a12.08,12.08,0,1,1,0-24.16h26.27a11.59,11.59,0,0,1-5.82-10.08v-.94a11.68,11.68,0,0,1,11.68-11.68H414A11.68,11.68,0,0,1,425.66,194.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M212.66,284.9a13.24,13.24,0,0,0,2.1,20.39h39.53a13.2,13.2,0,1,1,0,26.39H125.93a13.2,13.2,0,0,1,0-26.39h14.38a13,13,0,0,0,2.1-1.71,13.19,13.19,0,0,0-2.22-20.45H29.46a13.21,13.21,0,0,1,0-26.41h91.87a13.32,13.32,0,0,0,1.64-1.38,13.22,13.22,0,0,0-8.23-22.49H78.51a13.2,13.2,0,1,1,0-26.39H83a12.66,12.66,0,0,0,7.61-11.9v-1a12.64,12.64,0,0,0-8.17-12.13H45.07a11.69,11.69,0,0,1-11.68-11.68v-1a11.7,11.7,0,0,1,11.68-11.69h119.6a11.7,11.7,0,0,1,11.69,11.69v1a11.7,11.7,0,0,1-11.69,11.68H144.32a12.66,12.66,0,0,0-8.17,12.13v1a12.68,12.68,0,0,0,7.61,11.9h63.08A13.19,13.19,0,0,1,208,232.8h31.3a13.21,13.21,0,0,1,9.35,22.54,12.62,12.62,0,0,1-1.64,1.38h16.81a13.21,13.21,0,0,1,0,26.41H214.9A11.87,11.87,0,0,0,212.66,284.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 447.24,
    y: 180.72,
    width: 57.36,
    height: 23.11,
    rx: 11.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 406.3,
    y: 51.2,
    width: 41.55,
    height: 26.35,
    rx: 13.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 309.83,
    y: 283.98,
    width: 38.1,
    height: 22.9,
    rx: 11.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 161.03,
    y: 46.11,
    width: 154.44,
    height: 206.34,
    rx: 9.72,
    transform: "translate(25.07 -34.02) rotate(8.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.07,
    y: 50.37,
    width: 154.44,
    height: 206.34,
    rx: 9.72,
    transform: "translate(-21.53 40.75) rotate(-9.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M315.09,90.32V248a9.73,9.73,0,0,1-9.72,9.73H169.16a9.73,9.73,0,0,1-9.73-9.73V59.51a9.73,9.73,0,0,1,9.73-9.73H275Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M275.77,85.33V49.78L315.7,89.71l-35.43.11A4.5,4.5,0,0,1,275.77,85.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 185.78,
    y: 110.59,
    width: 32.43,
    height: 32.43,
    rx: 6.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 236.45,
    y: 111.4,
    width: 45.4,
    height: 6.89,
    rx: 3.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 236.45,
    y: 143.63,
    width: 45.4,
    height: 6.89,
    rx: 3.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 183.55,
    y: 176.46,
    width: 98.3,
    height: 6.89,
    rx: 3.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 183.55,
    y: 209.09,
    width: 98.3,
    height: 6.89,
    rx: 3.45
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfound);
export default __webpack_public_path__ + "static/media/notfound.b77abd68976f91b2f13fb74b5ceb72f6.svg";
export { ForwardRef as ReactComponent };